import { APP_INITIALIZER, Provider } from '@angular/core';
import { CheckUpdatesService } from '@klubovna/shared-data';

export function appInitializerFactory(updateService: CheckUpdatesService): () => Promise<void> {
  return () => updateService.checkForUpdates();
}

export const AppInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: appInitializerFactory,
  deps: [ CheckUpdatesService ],
  multi: true,
};
